// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.datelist .cal-body {\n  border: none;\n}\n.event {\n  clear: both;\n  margin-bottom: 10px;\n}\n.passclass {\n  margin-bottom: 30px;\n}\n.showblurb {\n  max-height: 100px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.soldout {\n  text-decoration: line-through;\n}\n", ""]);
// Exports
module.exports = exports;
